import { Component, Input, OnInit } from '@angular/core';
import { HotspotType } from '../hotspot-type.model';

@Component({
  selector   : 'app-hotspot-type-icon',
  templateUrl: './hotspot-type-icon.component.html',
  styleUrls  : ['./hotspot-type-icon.component.scss']
})
export class HotspotTypeIconComponent implements OnInit {

  hotspotTypes = HotspotType;

  @Input()
  type = HotspotType;

  constructor() {
  }

  ngOnInit() {
  }

}
